
import { selectRetailer } from 'utils/rw-subordinates/actions/subordinate-list.actions';

import template from './rw-multistore-selector-dialog.html';

const mapStateToThis = () => ({});

const mapDispatchToThis = {
  selectRetailer,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class RwMultistoreSelectorDialogController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  onRetailerSelection(retailer) {
    this.selectRetailer(retailer);
    this.close();
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class RwMultistoreSelectorDialogComponent {
  constructor() {
    this.template = template;
    this.controller = RwMultistoreSelectorDialogController;
    this.bindings = {
      resolve: '<',
      close: '&',
      dismiss: '&',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-multistore-selector/components/rw-multistore-selector-dialog/rw-multistore-selector-dialog-component.js